// // blogPages.js
// // import BlogPage from "./blog/BlogPage";
// import BlogPage_1 from "./BlogPage_1";
// import BlogPage_2 from "./BlogPage_2";
// import BlogPage_3 from "./BlogPage_3";
// import BlogPage_4 from "./BlogPage_4";
// import BlogPage_5 from "./BlogPage_5";
// import BlogPage_6 from "./BlogPage_6";
// import BlogPage_7 from "./BlogPage_7";
// import BlogPage_8 from "./BlogPage_8";
// import BlogPage_9 from "./BlogPage_9";
// import BlogPage_10 from "./BlogPage_10";
// import BlogPage_11 from "./BlogPage_11";
// import BlogPage_12 from "./BlogPage_12";
// import BlogPage_13 from "./BlogPage_13";
// import BlogPage_14 from "./BlogPage_14";
// import BlogPage_15 from "./BlogPage_15";
// import BlogPage_16 from "./BlogPage_16";
// import BlogPage_17 from "./BlogPage_17";
//
//
//
// import { getPagesByType } from "../structure/jigpawsStructure";
//
// const blogs = getPagesByType("Blog");
// const components = [BlogPage_1, BlogPage_2, BlogPage_3, BlogPage_4, BlogPage_5, BlogPage_6, BlogPage_7, BlogPage_8, BlogPage_9, BlogPage_10, BlogPage_11, BlogPage_12, BlogPage_13, BlogPage_14, BlogPage_15, BlogPage_16, BlogPage_17];
//
// const BlogPages = blogs.map((blog, index) => ({
//   path: blog.relLink,
//   component: components[index]
// }));

import React from "react";
import { getPagesByType } from "../structure/jigpawsStructure";
import { Suspense } from "react";


const MAX_BLOGS = 31;

const components = Array.from({ length: MAX_BLOGS }, (_, i) =>
  React.lazy(() => import(`./BlogPage_${i + 1}`))
);

const blogs = getPagesByType("Blog");

const blogPages = blogs.map((blog, index) => ({
  path: blog.relLink,
  component: () => (
    <Suspense fallback={<div style={{ minHeight: "100vh" }} />}>
      {React.createElement(components[index])}
    </Suspense>
  )
}));

export default blogPages;
